// extracted by mini-css-extract-plugin
module.exports = {"privacy-policy":"PrivacyPolicy_privacy-policy__TX6rL"};